import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { Store } from '@ngrx/store';
import * as fromSettingSelector from '../../../store/settings/settings.selectors';
import * as fromTeamsSelectors from '../../../store/team/team.selectors';
import * as fromCapacityActions from '../../../store/capacity/capacity.actions';
import * as fromCapacitySelectors from '../../../store/capacity/capacity.adapter';
import * as fromSlotActions from '../../../store/slot/slot.actions';
import * as fromSlotSelector from '../../../store/slot/slot.selectors';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import { Observable, Subscription } from 'rxjs';
import { IEmployee, IGeneralSettings, ITeam, ITransportOption } from '@signal/asp-data-commons';
import * as fromEmployeeSelectors from '../../../store/employee/employee.selectors';
import { TeamState } from 'src/app/modules/store/team/team.reducer';
import { SlotState } from 'src/app/modules/store/slot/slot.reducer';
import { ShopMaxPerDay } from 'src/app/modules/shared/models/slot-management.model';
import { CapacityState } from 'src/app/modules/store/capacity/capacity.reducer';
import { IAvailability, IDateAvailability, IOverrideCapacity, ITeamHrCapacity } from '@signal/asp-data-commons';
import { IDashboardDetails, ScheduleDashboardState } from 'src/app/modules/store/schedule-dashboard/schedule-dashboard.reducer';
import * as fromScheduleDashboardSelector from '../../../store/schedule-dashboard/schedule-dashboard.selectors';
//import { LoadAvailability } from '../../../store/service-appointment/service-appointment.actions';
import { ServiceAppointmentState } from 'src/app/modules/store/service-appointment/service-appointment.reducer';
//import * as fromAvailabilitySelectors from 'src/app/modules/store/service-appointment/service-appointment.selectors';
@Component({
  selector: 'app-override-dialog',
  templateUrl: './override-dialog.component.html',
  styleUrls: ['./override-dialog.component.scss']
})
export class OverrideDialogComponent implements OnInit,OnDestroy {


  overrideForm: UntypedFormGroup;
  dashboardDetails$ : Observable<IDashboardDetails>;
  currentDate: Date;
  dayOfWeek: string;
  shopMaxTotal$: Observable<ShopMaxPerDay[]>;
  dealerSettings$: Observable<IGeneralSettings>;
  subscriptions: Subscription[] = [];
  capacitySubscription : Subscription;
  teams$: Observable<ITeam[]>;
  teamList: ITeam[] = [];
  transportOptionsData: ITransportOption[] = [];
  capacityOverride$: Observable<IOverrideCapacity>;
  capacityOverrideData: IOverrideCapacity = null;
  teamFlatRateHours$: Observable<number>;
  shopHrsVal: number;
  actualShopHrs: number;
  slotAvailability$: Observable<IAvailability>;
  slotDateData: IDateAvailability[] = [];
  dateFormat = 'yyyy-MM-dd';

  // transportOptions = [
  //   { id: 'SHUTTLE', name: 'Shuttle' },
  //   { id: 'RENTAL', name: 'Rental' },
  //   { id: 'DROP-OFF', name: 'Drop Off' },
  //   { id: 'WAITER', name: 'Wait' },
  //   { id: 'REMOTE', name: 'Remote'}
  // ];
  constructor(private readonly slotState: Store<SlotState>, private capacityState: Store<CapacityState>, private readonly teamsState: Store<TeamState>, private employeeState: Store<IEmployee>,
    public dialogRef: MatDialogRef<OverrideDialogComponent>, private readonly formBuilder: UntypedFormBuilder, private settingsState: Store<SettingsState>, private scheduleDashboardState: Store<ScheduleDashboardState>,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>) {

    this.overrideForm = this.formBuilder.group({
      date: [DateTime.now().toFormat(this.dateFormat)],
      totalShopHrs: [null, [Validators.required]],
      transportOptions: this.formBuilder.array([]),
      TeamTechnicianHours: this.formBuilder.array([])
    });

  }

  ngOnInit(): void {
    this.setUpStore();
  }

  get transportOptionsArr() {
    return (this.overrideForm.get('transportOptions') as UntypedFormArray).length > 0 ?  this.overrideForm.get('transportOptions') as UntypedFormArray : null;
  }

  get teamTechHrsArr() {
    return (this.overrideForm.get('TeamTechnicianHours') as UntypedFormArray).length > 0 ? this.overrideForm.get('TeamTechnicianHours') as UntypedFormArray : null;
  }





  initializeSubs() {
    this.subscriptions.push(this.dealerSettings$.subscribe(t => {
      if (t.transport) {
        this.transportOptionsData = t.transport?.transportOptions;
        this.transportOptionsData.forEach(trans => {
          (this.overrideForm.get('transportOptions') as UntypedFormArray).push(new UntypedFormGroup({
            id: new UntypedFormControl(trans.id),
            category: new UntypedFormControl(trans.category),
            label: new UntypedFormControl(trans.label),
            isActive: new UntypedFormControl(trans.isActive),
            comments: new UntypedFormControl(trans.comments),
            cost: new UntypedFormControl(trans.cost),
            flatRateHours: new UntypedFormControl(trans.flatRateHours),
            estimatedDuration: new UntypedFormControl(trans.estimatedDuration)
          }));
        })
        this.initializeFormData();
      }
    }));

    this.subscriptions.push(this.dashboardDetails$.subscribe(details => {
      if(details.selectedDate){
        this.overrideForm.get('date').setValue(details.selectedDate.toFormat(this.dateFormat));
        this.currentDate = new Date(details.selectedDate.toISO());
        // this.dayOfWeek = details.selectedDate.weekdayShort;
        this.setUpCapacityStoreAndSub();
      }
    }));

    this.subscriptions.push(this.slotAvailability$.subscribe(slotAvailability => {
        if( slotAvailability.availableDates){
          this.slotDateData = slotAvailability.availableDates;
          const date = this.overrideForm.value.date;
          this.shopHrsVal = this.slotDateData.find(x => x.date === date).totalLaborHour;
          this.actualShopHrs = this.slotDateData.find(x => x.date === date).actualShopHrs;
          this.initializeFormData();
        }
    }));

    /*this.subscriptions.push(this.shopMaxTotal$.subscribe(val => {
      if(val.length > 0){
        this.shopHrsVal = val.find(x=>x.dayOfWeek === this.dayOfWeek.toUpperCase()).flatRateHours;
        this.initializeFormData();
      }
    }));*/

    this.subscriptions.push(this.teams$.subscribe(teamList => {
      if(teamList.length > 0) {
        this.teamList = teamList;
        this.teamList.forEach(t => {
          (this.overrideForm.get('TeamTechnicianHours') as UntypedFormArray).push(new UntypedFormGroup({
            teamId: new UntypedFormControl(t.id),
            teamName: new UntypedFormControl(t.name),
            totalHrs: new UntypedFormControl(0),
            duptotalHrs: new UntypedFormControl(0),
          }));
        })
        this.initializeFormData();
      }
    }));

  }

  initializeFormData(){

    if(this.capacityOverrideData && this.capacityOverrideData.date){
      this.overrideForm.get('totalShopHrs').setValue(this.capacityOverrideData.totalShopHrs);
      this.overrideForm.get('date').patchValue(this.capacityOverrideData.date);
      if(this.teamList.length > 0){
      this.overrideForm.get('TeamTechnicianHours').patchValue(this.capacityOverrideData.TeamTechnicianHours);
      }
      this.overrideForm.get('transportOptions').patchValue(this.capacityOverrideData.transportOptions);
    } else {
       this.overrideForm.get('totalShopHrs').patchValue(this.shopHrsVal);
      this.teamList.forEach((team, index) => {
        const props = {employeeIds: team.employeeIds};
        this.teamFlatRateHours$ = this.employeeState.select(fromEmployeeSelectors.selectFlatRateHoursByIds, props);
        this.subscriptions.push(this.teamFlatRateHours$.subscribe(data => {
          (this.overrideForm.get('TeamTechnicianHours') as UntypedFormArray).controls[index].get('totalHrs').setValue(data);
          (this.overrideForm.get('TeamTechnicianHours') as UntypedFormArray).controls[index].get('duptotalHrs').setValue(data);
        }));
      })
    }
  }

  setUpStore(){
    const obj = {
      department: 'service',
    };
    this.slotState.dispatch(new fromSlotActions.LoadShopMaxTotal());    
    //this.settingsState.dispatch(new fromActions.LoadSettings(obj));
    //this.serviceAppointmentState.dispatch(new LoadAvailability({ date:'', advisorId: '-1', transport: 'DROP-OFF' }));
    //this.slotAvailability$ = this.serviceAppointmentState.select(fromAvailabilitySelectors.selectAvailabilityData);
    this.dealerSettings$ = this.settingsState.select(fromSettingSelector.selectSettings);
    this.teams$ = this.teamsState.select(fromTeamsSelectors.selectTeams);
    this.dashboardDetails$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardDetails);
    this.shopMaxTotal$ = this.slotState.select(fromSlotSelector.selectShopMaxTotal);
    this.slotAvailability$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardSlot, {department: 'service'});
    this.initializeSubs();
  }

  setUpCapacityStoreAndSub(){
    this.capacityState.dispatch(new fromCapacityActions.LoadCapacityOverrideForDate(this.overrideForm.value.date));
    this.capacityOverride$ = this.capacityState.select(fromCapacitySelectors.selectCapacityOverride);
    this.capacitySubscription = this.capacityOverride$.subscribe(data => {
      if(data && data.date){
        this.capacityOverrideData = data;
        this.initializeFormData();
      }
    });
  }

  onCancel(){
    this.dialogRef.close();
  }

  onSave(){
    this.overrideForm.value.TeamTechnicianHours.forEach(element => {
      delete element.duptotalHrs;
    });
    this.capacityState.dispatch(new fromCapacityActions.UpdateCapacityOverride(this.overrideForm.value));
    this.dialogRef.close();
  }

  ngOnDestroy(){
    this.capacitySubscription.unsubscribe();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
